export default {
  'open-menu': 'Open menu',
  'close-menu': 'Close',
  'editorial-staff': 'Editorial team',
  about: 'This is us',
  shopLink: 'A world of possibilities',
}
